/* ============================================================
   RURU — self-contained cart drawer (Shopify)
   Drop-in asset. Injects a slide-out cart drawer that reads the
   REAL Shopify cart (/cart.js), so prices & currency are always
   correct for the visitor's market. No markup needed in the page.

   Works with the existing product section which dispatches:
     document.dispatchEvent(new CustomEvent('cart:open'))
     document.dispatchEvent(new CustomEvent('cart:refresh'))

   Open it from anything with  data-cart-open
   Show a live count on anything with  data-cart-count
   ============================================================ */
(function () {
  if (window.RuruCartDrawer) return;
  // If the homepage section's own drawer is present, don't double up.
  if (document.querySelector('[data-cart-drawer]')) { window.RuruCartDrawer = { skipped: true }; return; }

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Styles ---- */
  var css = ''
  + '.rcx-count{position:absolute;top:2px;right:2px;min-width:19px;height:19px;padding:0 5px;border-radius:999px;background:var(--ink,#3D2B1F);color:var(--bg-1,#F4EFE6);border:2px solid var(--card,#fff);font-size:11px;font-weight:800;line-height:15px;display:grid;place-items:center;transform:scale(0);transition:transform .3s cubic-bezier(.16,1,.3,1);font-variant-numeric:tabular-nums;pointer-events:none;z-index:2;}'
  + '.rcx-count.has-items{transform:scale(1);}'
  + '.rcx-count.bump{animation:rcx-bump .45s cubic-bezier(.16,1,.3,1);}'
  + '@keyframes rcx-bump{0%{transform:scale(1);}40%{transform:scale(1.6);}100%{transform:scale(1);}}'
  + '.rcx-overlay{position:fixed;inset:0;z-index:9998;background:rgba(61,43,31,.38);backdrop-filter:blur(3px);-webkit-backdrop-filter:blur(3px);opacity:0;pointer-events:none;transition:opacity .4s cubic-bezier(.16,1,.3,1);}'
  + '.rcx-overlay.open{opacity:1;pointer-events:auto;}'
  + '.rcx-drawer{position:fixed;top:0;right:0;bottom:0;z-index:9999;width:min(430px,93vw);background:var(--card,#FFFDF8);box-shadow:-30px 0 70px -24px rgba(61,43,31,.4);transform:translateX(105%);transition:transform .5s cubic-bezier(.16,1,.3,1);display:flex;flex-direction:column;font-family:var(--font-body,"Plus Jakarta Sans",system-ui,sans-serif);color:var(--ink,#3D2B1F);}'
  + '.rcx-drawer.open{transform:translateX(0);}'
  + '.rcx-head{display:flex;align-items:center;justify-content:space-between;padding:24px 26px 20px;border-bottom:1px solid var(--line,rgba(61,43,31,.1));}'
  + '.rcx-head h3{margin:0;font-family:var(--font-display,"Sora",sans-serif);font-size:21px;font-weight:800;letter-spacing:-.02em;display:flex;align-items:baseline;gap:8px;}'
  + '.rcx-head .lbl{font-size:12.5px;color:var(--ink-mute,#9A8779);font-weight:600;}'
  + '.rcx-x{width:40px;height:40px;border-radius:12px;border:1px solid var(--line,rgba(61,43,31,.1));background:transparent;cursor:pointer;display:grid;place-items:center;color:var(--ink,#3D2B1F);transition:background .2s,transform .2s;}'
  + '.rcx-x:hover{background:rgba(61,43,31,.06);transform:rotate(90deg);}'
  + '.rcx-body{flex:1;overflow-y:auto;padding:6px 26px;}'
  + '.rcx-empty{display:none;flex-direction:column;align-items:center;justify-content:center;text-align:center;height:100%;gap:16px;color:var(--ink-mute,#9A8779);padding:48px 0;}'
  + '.rcx-empty svg{color:var(--line-strong,rgba(61,43,31,.18));}'
  + '.rcx-empty p{margin:0;font-weight:700;font-size:15px;color:var(--ink-soft,#6B5446);}'
  + '.rcx-drawer.is-empty .rcx-empty{display:flex;}'
  + '.rcx-drawer.is-empty .rcx-foot{display:none;}'
  + '.rcx-item{display:grid;grid-template-columns:70px 1fr auto;gap:16px;align-items:center;padding:20px 0;border-bottom:1px solid var(--line,rgba(61,43,31,.1));animation:rcx-in .5s cubic-bezier(.16,1,.3,1);}'
  + '@keyframes rcx-in{from{opacity:0;transform:translateX(20px);}to{opacity:1;transform:none;}}'
  + '.rcx-item.removing{opacity:.4;pointer-events:none;}'
  + '.rcx-thumb{width:70px;height:70px;border-radius:16px;overflow:hidden;background:rgba(224,169,59,.12);display:grid;place-items:center;}'
  + '.rcx-thumb img{width:100%;height:100%;object-fit:contain;}'
  + '.rcx-name{font-weight:700;font-size:15.5px;letter-spacing:-.01em;}'
  + '.rcx-sub{font-size:12.5px;color:var(--ink-soft,#6B5446);margin-top:3px;}'
  + '.rcx-right{display:flex;flex-direction:column;align-items:flex-end;gap:10px;}'
  + '.rcx-line{font-weight:700;font-size:14px;}'
  + '.rcx-stepper{display:inline-flex;align-items:center;border:1px solid var(--line-strong,rgba(61,43,31,.18));border-radius:999px;overflow:hidden;}'
  + '.rcx-stepper button{width:28px;height:28px;border:none;background:transparent;cursor:pointer;font-size:16px;color:var(--ink,#3D2B1F);display:grid;place-items:center;transition:background .15s;}'
  + '.rcx-stepper button:hover{background:rgba(61,43,31,.07);}'
  + '.rcx-stepper span{min-width:26px;text-align:center;font-weight:800;font-size:13px;font-variant-numeric:tabular-nums;}'
  + '.rcx-remove{background:none;border:none;cursor:pointer;color:var(--ink-mute,#9A8779);font-size:12px;font-weight:600;padding:0;transition:color .15s;}'
  + '.rcx-remove:hover{color:var(--ink,#3D2B1F);}'
  + '.rcx-perks{display:flex;flex-wrap:wrap;gap:8px 14px;padding:18px 0 4px;}'
  + '.rcx-perk{display:flex;align-items:center;gap:6px;font-size:12px;font-weight:600;color:var(--ink-soft,#6B5446);}'
  + '.rcx-perk svg{color:var(--pistachio-deep,#84994E);flex-shrink:0;}'
  + '.rcx-foot{border-top:1px solid var(--line,rgba(61,43,31,.1));padding:22px 26px;display:flex;flex-direction:column;gap:16px;background:linear-gradient(180deg,rgba(224,169,59,0),rgba(224,169,59,.04));}'
  + '.rcx-sumrow{display:flex;align-items:center;justify-content:space-between;font-size:13.5px;color:var(--ink-soft,#6B5446);}'
  + '.rcx-sumrow.total{align-items:baseline;}'
  + '.rcx-sumrow.total .l{font-weight:700;color:var(--ink,#3D2B1F);font-size:15px;}'
  + '.rcx-sumrow.total .v{font-weight:800;font-size:24px;letter-spacing:-.02em;color:var(--ink,#3D2B1F);}'
  + '.rcx-save{color:var(--pistachio-deep,#84994E);font-weight:700;}'
  + '.rcx-checkout{width:100%;justify-content:center;font-size:15.5px;}'
  + '.rcx-note{font-size:11.5px;color:var(--ink-mute,#9A8779);text-align:center;}'
  + '@media (prefers-reduced-motion:reduce){.rcx-overlay,.rcx-drawer,.rcx-item,.rcx-x{transition:none;animation:none;}}';
  var style = document.createElement('style');
  style.id = 'ruru-cart-drawer-styles';
  style.textContent = css;
  document.head.appendChild(style);

  /* ---- Markup ---- */
  var overlay = document.createElement('div');
  overlay.className = 'rcx-overlay';
  overlay.setAttribute('data-cart-close', '');

  var drawer = document.createElement('aside');
  drawer.className = 'rcx-drawer is-empty';
  drawer.setAttribute('role', 'dialog');
  drawer.setAttribute('aria-label', 'Shopping cart');
  drawer.setAttribute('aria-hidden', 'true');
  drawer.innerHTML = ''
  + '<div class="rcx-head">'
  +   '<h3>Your cart <span class="lbl" data-rcx-headcount></span></h3>'
  +   '<button type="button" class="rcx-x" data-cart-close aria-label="Close cart"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg></button>'
  + '</div>'
  + '<div class="rcx-body">'
  +   '<div class="rcx-empty">'
  +     '<svg width="46" height="46" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"><path d="M5 8h14l-1.2 11.1a2 2 0 0 1-2 1.9H8.2a2 2 0 0 1-2-1.9L5 8Z"/><path d="M9 8V6a3 3 0 0 1 6 0v2"/></svg>'
  +     '<p>Your cart is empty</p>'
  +   '</div>'
  +   '<div data-rcx-items></div>'
  +   '<div class="rcx-perks">'
  +     '<span class="rcx-perk"><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5 10 17.5l9-11"/></svg> Free shipping</span>'
  +     '<span class="rcx-perk"><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5 10 17.5l9-11"/></svg> 14-day returns</span>'
  +     '<span class="rcx-perk"><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5 10 17.5l9-11"/></svg> 12-month warranty</span>'
  +   '</div>'
  + '</div>'
  + '<div class="rcx-foot">'
  +   '<div class="rcx-sumrow total"><span class="l">Subtotal</span><span class="v" data-rcx-total>—</span></div>'
  +   '<p class="rcx-note">Shipping &amp; taxes calculated at checkout.</p>'
  +   '<form action="/cart" method="post" novalidate>'
  +     '<button type="submit" name="checkout" class="btn btn-mustard rcx-checkout">Proceed to checkout <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M13 6l6 6-6 6"/></svg></button>'
  +   '</form>'
  + '</div>';

  function mount() {
    document.body.appendChild(overlay);
    document.body.appendChild(drawer);
    load();
  }

  var itemsEl = function () { return drawer.querySelector('[data-rcx-items]'); };

  /* ---- Money ---- */
  function formatMoney(cents, currency) {
    try {
      if (window.Shopify && Shopify.formatMoney && window.theme && theme.moneyFormat) {
        return Shopify.formatMoney(cents, theme.moneyFormat);
      }
    } catch (e) {}
    try {
      return new Intl.NumberFormat(navigator.language || 'en', { style: 'currency', currency: currency || 'EUR' }).format(cents / 100);
    } catch (e) {}
    return (cents / 100).toFixed(2);
  }

  /* ---- Render ---- */
  function refreshBadges(count, bump) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      if (el.hasAttribute('hidden')) el.hidden = count > 0 ? false : true;
      el.classList.toggle('has-items', count > 0);
      if (bump && count > 0) { el.classList.remove('bump'); void el.offsetWidth; el.classList.add('bump'); }
    });
  }

  function render(cart) {
    var count = cart ? cart.item_count : 0;
    drawer.classList.toggle('is-empty', count === 0);
    var hc = drawer.querySelector('[data-rcx-headcount]');
    if (hc) hc.textContent = count > 0 ? ('· ' + count + ' item' + (count > 1 ? 's' : '')) : '';
    drawer.querySelector('[data-rcx-total]').textContent = count > 0 ? formatMoney(cart.total_price, cart.currency) : '—';
    if (count > 0) {
      itemsEl().innerHTML = cart.items.map(function (it) {
        var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_120x120$1$2') : '';
        return ''
        + '<div class="rcx-item" data-key="' + it.key + '">'
        +   '<div class="rcx-thumb">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</div>'
        +   '<div><div class="rcx-name">' + it.product_title + '</div>'
        +     '<div class="rcx-sub">' + formatMoney(it.final_price, cart.currency) + ' each</div></div>'
        +   '<div class="rcx-right">'
        +     '<div class="rcx-line">' + formatMoney(it.final_line_price, cart.currency) + '</div>'
        +     '<div class="rcx-stepper"><button type="button" data-rcx-minus aria-label="Decrease">−</button><span>' + it.quantity + '</span><button type="button" data-rcx-plus aria-label="Increase">+</button></div>'
        +     '<button type="button" class="rcx-remove" data-rcx-remove>Remove</button>'
        +   '</div>'
        + '</div>';
      }).join('');
    } else {
      itemsEl().innerHTML = '';
    }
    refreshBadges(count, false);
  }

  var lastCount = 0;
  function load() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var bump = cart.item_count > lastCount;
        render(cart);
        if (bump) refreshBadges(cart.item_count, true);
        lastCount = cart.item_count;
        return cart;
      }).catch(function () {});
  }

  function changeLine(key, qty, rowEl) {
    if (qty === 0 && rowEl) rowEl.classList.add('removing');
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); })
      .then(function (cart) { render(cart); lastCount = cart.item_count; })
      .catch(function () {});
  }

  /* ---- Open / close ---- */
  function open() {
    overlay.classList.add('open');
    drawer.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    load();
  }
  function close() {
    overlay.classList.remove('open');
    drawer.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  /* ---- Events (document-level delegation) ---- */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-open]')) { e.preventDefault(); open(); return; }
    if (e.target.closest('[data-cart-close]')) { e.preventDefault(); close(); return; }
    var row = e.target.closest('.rcx-item');
    if (!row) return;
    var key = row.getAttribute('data-key');
    var qtyEl = row.querySelector('.rcx-stepper span');
    var qty = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
    if (e.target.closest('[data-rcx-plus]')) changeLine(key, qty + 1, row);
    else if (e.target.closest('[data-rcx-minus]')) changeLine(key, Math.max(0, qty - 1), row);
    else if (e.target.closest('[data-rcx-remove]')) changeLine(key, 0, row);
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  document.addEventListener('cart:refresh', function () { load(); });
  document.addEventListener('cart:open', function () { open(); });

  /* ---- Boot ---- */
  if (document.body) mount();
  else document.addEventListener('DOMContentLoaded', mount);

  window.RuruCartDrawer = { open: open, close: close, refresh: load };
})();
